import Component from '../inherited/Component'

export default class MenuSwitcher extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._menuHandle = this._elem.dataset.menuSwitcher
    this._menuSwitchers = document.querySelectorAll('[data-menu-switcher]')
    this._menuElems = document.querySelectorAll('[data-menu]')
  }

  mount() {

    if(localStorage.getItem('menu') && localStorage.getItem('menu') == this._menuHandle) {
        this._toggleMenu()
    } else if(!localStorage.getItem('menu')) {
        this._menuSwitchers[0].classList.add('active')
        this._menuElems[0].classList.remove('is-hidden')
        localStorage.setItem('menu', this._menuHandle)
    }

    this._elem.addEventListener('click', (e) => {
        e.preventDefault()
        localStorage.setItem('menu', this._menuHandle)
        window.location = this._elem.attr('href')
    })

    this._elem.classList.add('shown')
  }

  _toggleMenu() {

        for(let switcher of this._menuSwitchers) {
            if(switcher == this._elem) {
                switcher.classList.add('active')
            } else {
                switcher.classList.remove('active')
            }
        }

        for(let elem of this._menuElems) {
            if(elem.dataset.menu == this._menuHandle) {
                elem.classList.remove('is-hidden')
            } else {
                elem.classList.add('is-hidden')
            }
        }

  }
}
